import { s as strFromU8, z as zlibSync, a as strToU8, M as MARK } from "./base-BHkG_thH.js";
const pack = (event) => {
  const _e = {
    ...event,
    v: MARK
  };
  return strFromU8(zlibSync(strToU8(JSON.stringify(_e))), true);
};
export {
  pack
};
//# sourceMappingURL=pack.js.map
